export default function GreenhouseControllerSelector({ controllers, value, onChange }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wide text-slate-500">
        Greenhouse controller
      </span>
      <select
        aria-label="Greenhouse controller"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm"
      >
        {!controllers.length && <option value="">No controllers registered</option>}
        {controllers.map((controller) => (
          <option key={controller.mac_slug} value={controller.mac_slug}>
            {controller.name || controller.mac_slug} — {controller.is_online ? "online" : "offline"}
          </option>
        ))}
      </select>
    </label>
  );
}
